export const CREATE_REPORT_ISSUE_REQUEST = 'HELPDESK/REPORT/ISSUE/CREATE/REQUEST';
export const CREATE_REPORT_ISSUE_SUCCESS = 'HELPDESK/REPORT/ISSUE/CREATE/SUCCESS';

export const OPEN_REPORT_ISSUE_MODAL = 'HELPDESK/REPORT/ISSUE/MODAL/OPEN';
export const CLOSE_REPORT_ISSUE_MODAL = 'HELPDESK/REPORT/ISSUE/MODAL/CLOSE';
